module.exports = __webpack_public_path__ + "img/sd-bb-c-1.81e1bb62.jpg";